import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { PLATFORMS } from "../lib/constants";
import { Ban, Send, Radio, Flame } from "lucide-react";

export const BanTicker = () => {
  const [items, setItems] = useState([]);
  const [bannedWeek, setBannedWeek] = useState(0);
  const [platform, setPlatform] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const load = () => {
      api.get("/feed", { params: { limit: 20 } }).then(({ data }) => setItems(data)).catch(() => {});
      api.get("/stats").then(({ data }) => setBannedWeek(data.banned_this_week || 0)).catch(() => {});
    };
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const filtered = platform ? items.filter((i) => i.platform === platform) : items;
  if (items.length === 0) return null;
  const loop = filtered.length ? [...filtered, ...filtered] : [];

  return (
    <div data-testid="ban-ticker" className="border-b border-[#1E293F] bg-[#0F1424]">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 sm:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-[#FF2A55]/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-[#FF2A55]">
          <Radio size={12} className="animate-pulse" /> Live Takedowns
        </span>

        <span data-testid="ban-counter" className="hidden shrink-0 items-center gap-1.5 rounded-full bg-[#FF2A55]/15 px-2.5 py-1 text-[11px] font-bold text-[#FF2A55] sm:flex">
          <Flame size={12} /> {bannedWeek} confirmed this week
        </span>

        <div className="marquee-mask relative flex-1 overflow-hidden">
          {loop.length ? (
            <div className="animate-marquee flex w-max gap-6 whitespace-nowrap">
              {loop.map((it, i) => {
                const isCheater = it.status === "banned" || it.status === "confirmed_cheater";
                return (
                <button
                  key={i}
                  onClick={() => navigate(`/players/${it.platform}/${encodeURIComponent(it.gamertag)}`)}
                  className="flex items-center gap-2 text-sm text-[#CBD5E1] transition-colors hover:text-white"
                >
                  {isCheater
                    ? <Ban size={13} className="text-[#FF2A55]" />
                    : <Send size={13} className="text-[#00FF87]" />}
                  <span className="font-semibold text-white">{it.gamertag}</span>
                  <span className="text-[#64748B]">·</span>
                  <span className="text-[#94A3B8]">{it.platform}</span>
                  <span className="text-[#64748B]">·</span>
                  <span className={isCheater ? "text-[#FF2A55]" : "text-[#00FF87]"}>
                    {isCheater ? "CONFIRMED CHEATER" : "Sent to 2K"}
                  </span>
                  {it.heat > 0 && <span className="text-[#FFB800]">🔥 {it.heat}</span>}
                </button>
                );
              })}
            </div>
          ) : (
            <span className="text-sm text-[#64748B]">No {platform} takedowns yet.</span>
          )}
        </div>

        <div className="hidden shrink-0 items-center gap-1 md:flex">
          {["", ...PLATFORMS].map((p) => (
            <button
              key={p || "all"}
              data-testid={`ticker-filter-${p || "all"}`}
              onClick={() => setPlatform(p)}
              className={`rounded-md px-2 py-1 text-[11px] font-semibold transition-colors ${
                platform === p ? "bg-[#00F0FF]/15 text-[#00F0FF]" : "text-[#64748B] hover:text-white"
              }`}
            >
              {p || "All"}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
